import {
    DELETE_MODULE_ERROR,
    DELETE_MODULE_SUCCESS
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case DELETE_MODULE_SUCCESS:
          return {
            ...state,
            deletedModuleData: action.payload,
          };
        case DELETE_MODULE_ERROR:
          return {
            ...state,
            deletedModuleError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    